export enum OrganType {
    Kidney  = 0,
    Liver   = 1,
}